import script from "./Home.vue?vue&type=script&setup=true&lang=js"
export * from "./Home.vue?vue&type=script&setup=true&lang=js"

import "./Home.vue?vue&type=style&index=0&id=d52e71b6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src437516949/src/dublinfarmstownhomes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d52e71b6"]])

export default __exports__